import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getProjectAssignments = async (projectId) => {
  const apiPath = `projects/${projectId}/assignments`;

  const signedRequest = await createSignedGetRequest({ apiPath });

  const response = await axios(signedRequest);

  return response.data;
};
